import React, { useEffect, useState } from 'react';
import { Nav, Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import TechnicalNavItem from './submit_application/TechnicalNavItem';
import bsfzNavigationsService from '@rd-web-markets/de/dist/services/bsfz_navigations.service';
import { useTranslation } from 'react-i18next';
const ClaimProjectReportDetailsNavigation = _ref => {
  let {
    firstFastCheck,
    claimGroup,
    report,
    page,
    id,
    loading,
    tabs,
    setTabs
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const {
    t
  } = useTranslation();
  useEffect(() => {
    const fetchData = async () => {
      const tabs = await bsfzNavigationsService.get(report.id);
      setTabs(tabs);
    };
    fetchData();
  }, [report.id, setTabs]);
  if (!tabs) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement(Nav, {
    variant: "tabs"
  }, /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'general',
    to: "/".concat(user.account_type, "/claim_groups/").concat(claimGroup.id, "/technical_proof/project_reports/").concat(report.id)
  }, t('bsfz_start_project'))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'first_fast_check',
    to: "/".concat(user.account_type, "/claim_groups/").concat(claimGroup.id, "/technical_proof/project_reports/").concat(report.id, "/first_fast_check")
  }, t('first_fast_check'))), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'creating_application',
    to: "/".concat(user.account_type, "/claim_groups/").concat(claimGroup.id, "/technical_proof/project_reports/").concat(report.id, "/creating_application/project_parameters"),
    disabled: loading || !firstFastCheck.should_advance
  }, t('creating_application'))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'submit_application',
    to: "/".concat(user.account_type, "/claim_groups/").concat(claimGroup.id, "/technical_proof/project_reports/").concat(report.id, "/submit_application/submission_overview"),
    disabled: loading || !firstFastCheck.should_advance
  }, t('submit_application'))), tabs.map(tab => {
    return /*#__PURE__*/React.createElement(TechnicalNavItem, {
      disabled: loading || !firstFastCheck.should_advance,
      key: tab.id,
      report: report,
      page: page,
      claimGroup: claimGroup,
      tab: tab,
      user: user,
      id: id
    });
  })), /*#__PURE__*/React.createElement(Nav.Item, {
    style: {
      borderLeft: '3px solid #0093E6'
    }
  }, /*#__PURE__*/React.createElement(Nav.Link, {
    disabled: loading,
    as: Link,
    active: page === 'bsfz_project_overview',
    to: "/".concat(user.account_type, "/claim_groups/").concat(claimGroup.id, "/technical_proof/project_reports/").concat(report.id, "/bsfz_project_overview")
  }, t('bsfz_team')))));
};
export default ClaimProjectReportDetailsNavigation;